import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { FormFieldLabel } from 'components/_basic/Form/FormField/FormFieldLabel';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { NumericBox } from 'components/BusinessToolForm/components/NumericBox';

import { concatWithDot } from 'helpers/string';

import { STAGES_NAMES } from '../../utils/form';

export const SalesStages: React.FC<{ name: string; disabled?: boolean; index: number }> = memo(
  ({ name, disabled, index }) => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    return (
      <>
        <BorderedCard>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                <Grid item xs={12}>
                  <FormFieldLabel htmlFor={concatWithDot(name, STAGES_NAMES.STAGE)} disabled={disabled}>
                    {t('marketingAndSales.sales.stages.stage')}
                  </FormFieldLabel>
                  <Grid spacing={1} container>
                    <Grid item xs="auto">
                      <NumericBox number={index + 1} />
                    </Grid>
                    <Grid item xs>
                      <TextInputControl
                        control={control}
                        id={concatWithDot(name, STAGES_NAMES.STAGE)}
                        name={concatWithDot(name, STAGES_NAMES.STAGE)}
                        disabled={disabled}
                        maxLength={150}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextInputControl
                multiline
                control={control}
                id={concatWithDot(name, STAGES_NAMES.DESCRIPTION)}
                name={concatWithDot(name, STAGES_NAMES.DESCRIPTION)}
                minRows={4}
                label={t('marketingAndSales.sales.stages.description')}
                disabled={disabled}
                maxLength={500}
              />
            </Grid>
          </Grid>
        </BorderedCard>
      </>
    );
  },
);
